import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)


export function createRouter () {
  
  return new Router({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {     
      document.getElementById('header_all').scrollIntoView();
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js